{
  "NS_TO_JURONG_EAST": {
    "weekday": {
      "NS10": 1477,
      "NS16": 1458,
      "NS17": 1454,
      "NS18": 1452,
      "NS2": 1500,
      "NS3": 1497,
      "NS12": 1471,
      "NS4": 1493,
      "NS25": 1435,
      "NS24": 1437,
      "NS14": 1466,
      "NS7": 1485,
      "NS27": 1430,
      "NS28": 1428,
      "NS8": 1483,
      "NS21": 1444,
      "NS20": 1447,
      "NS22": 1442,
      "NS26": 1433,
      "NS11": 1474,
      "NS23": 1439,
      "NS19": 1449,
      "NS9": 1480,
      "NS5": 1490,
      "NS15": 1460,
      "NS13": 1468
    },
    "saturday": {
      "NS10": 1477,
      "NS16": 1458,
      "NS17": 1454,
      "NS18": 1452,
      "NS2": 1500,
      "NS3": 1497,
      "NS12": 1471,
      "NS4": 1493,
      "NS25": 1435,
      "NS24": 1437,
      "NS14": 1466,
      "NS7": 1485,
      "NS27": 1430,
      "NS28": 1428,
      "NS8": 1483,
      "NS21": 1444,
      "NS20": 1447,
      "NS22": 1442,
      "NS26": 1433,
      "NS11": 1474,
      "NS23": 1439,
      "NS19": 1449,
      "NS9": 1480,
      "NS5": 1490,
      "NS15": 1460,
      "NS13": 1468
    },
    "sunday-public-holiday": {
      "NS10": 1477,
      "NS16": 1458,
      "NS17": 1454,
      "NS18": 1452,
      "NS2": 1500,
      "NS3": 1497,
      "NS12": 1471,
      "NS4": 1493,
      "NS25": 1435,
      "NS24": 1437,
      "NS14": 1466,
      "NS7": 1485,
      "NS27": 1430,
      "NS28": 1428,
      "NS8": 1483,
      "NS21": 1444,
      "NS20": 1447,
      "NS22": 1442,
      "NS26": 1433,
      "NS11": 1474,
      "NS23": 1439,
      "NS19": 1449,
      "NS9": 1480,
      "NS5": 1490,
      "NS15": 1460,
      "NS13": 1468
    },
    "public-holiday-eve": {
      "NS10": 1511,
      "NS16": 1492,
      "NS17": 1488,
      "NS18": 1486,
      "NS2": 1533,
      "NS3": 1530,
      "NS12": 1505,
      "NS4": 1526,
      "NS25": 1470,
      "NS24": 1435,
      "NS14": 1500,
      "NS7": 1519,
      "NS27": 1465,
      "NS28": 1462,
      "NS8": 1516,
      "NS21": 1479,
      "NS20": 1481,
      "NS22": 1476,
      "NS26": 1467,
      "NS11": 1508,
      "NS23": 1474,
      "NS19": 1484,
      "NS9": 1514,
      "NS5": 1524,
      "NS15": 1494,
      "NS13": 1502
    }
  },
  "NS_TO_MARINA_SOUTH_PIER": {
    "weekday": {
      "NS10": 1391,
      "NS16": 1411,
      "NS17": 1414,
      "NS18": 1416,
      "NS2": 1369,
      "NS3": 1371,
      "NS12": 1397,
      "NS4": 1376,
      "NS25": 1433,
      "NS24": 1431,
      "NS1": 1366,
      "NS14": 1402,
      "NS7": 1383,
      "NS27": 1438,
      "NS8": 1386,
      "NS21": 1424,
      "NS20": 1421,
      "NS22": 1426,
      "NS26": 1435,
      "NS11": 1394,
      "NS23": 1428,
      "NS19": 1419,
      "NS9": 1388,
      "NS5": 1378,
      "NS15": 1408,
      "NS13": 1400
    },
    "saturday": {
      "NS10": 1391,
      "NS16": 1411,
      "NS17": 1414,
      "NS18": 1416,
      "NS2": 1369,
      "NS3": 1371,
      "NS12": 1397,
      "NS4": 1376,
      "NS25": 1433,
      "NS24": 1431,
      "NS1": 1366,
      "NS14": 1402,
      "NS7": 1383,
      "NS27": 1438,
      "NS8": 1386,
      "NS21": 1424,
      "NS20": 1421,
      "NS22": 1426,
      "NS26": 1435,
      "NS11": 1394,
      "NS23": 1428,
      "NS19": 1419,
      "NS9": 1388,
      "NS5": 1378,
      "NS15": 1408,
      "NS13": 1400
    },
    "sunday-public-holiday": {
      "NS10": 1391,
      "NS16": 1411,
      "NS17": 1414,
      "NS18": 1416,
      "NS2": 1369,
      "NS3": 1371,
      "NS12": 1397,
      "NS4": 1376,
      "NS25": 1433,
      "NS24": 1431,
      "NS1": 1366,
      "NS14": 1402,
      "NS7": 1383,
      "NS27": 1438,
      "NS8": 1386,
      "NS21": 1424,
      "NS20": 1421,
      "NS22": 1426,
      "NS26": 1435,
      "NS11": 1394,
      "NS23": 1428,
      "NS19": 1419,
      "NS9": 1388,
      "NS5": 1378,
      "NS15": 1408,
      "NS13": 1400
    },
    "public-holiday-eve": {
      "NS10": 1428,
      "NS16": 1448,
      "NS17": 1451,
      "NS18": 1453,
      "NS2": 1407,
      "NS3": 1409,
      "NS12": 1434,
      "NS4": 1413,
      "NS25": 1470,
      "NS24": 1467,
      "NS1": 1403,
      "NS14": 1440,
      "NS7": 1420,
      "NS27": 1474,
      "NS8": 1423,
      "NS21": 1460,
      "NS20": 1458,
      "NS22": 1463,
      "NS26": 1472,
      "NS11": 1432,
      "NS23": 1465,
      "NS19": 1455,
      "NS9": 1426,
      "NS5": 1416,
      "NS15": 1445,
      "NS13": 1437
    }
  },
  "EW_TO_TUAS_LINK": {
    "weekday": {
      "EW9": 1426,
      "EW5": 1416,
      "EW27": 1472,
      "EW12": 1433,
      "EW21": 1455,
      "EW25": 1467,
      "EW13": 1435,
      "EW23": 1460,
      "EW20": 1452,
      "EW22": 1457,
      "EW7": 1421,
      "EW30": 1481,
      "EW29": 1478,
      "EW24": 1465,
      "EW10": 1428,
      "EW6": 1419,
      "EW26": 1469,
      "EW11": 1430,
      "EW16": 1442,
      "EW1": 1403,
      "EW8": 1423,
      "EW28": 1475,
      "EW19": 1450,
      "EW14": 1438,
      "EW18": 1448,
      "EW3": 1409,
      "EW2": 1406,
      "EW4": 1413,
      "EW15": 1440,
      "EW17": 1445,
      "EW31": 1484,
      "EW32": 1486
    },
    "saturday": {
      "EW9": 1426,
      "EW5": 1416,
      "EW27": 1472,
      "EW12": 1433,
      "EW21": 1455,
      "EW25": 1467,
      "EW13": 1435,
      "EW23": 1460,
      "EW20": 1452,
      "EW22": 1457,
      "EW7": 1421,
      "EW30": 1481,
      "EW29": 1478,
      "EW24": 1465,
      "EW10": 1428,
      "EW6": 1419,
      "EW26": 1469,
      "EW11": 1430,
      "EW16": 1442,
      "EW1": 1403,
      "EW8": 1423,
      "EW28": 1475,
      "EW19": 1450,
      "EW14": 1438,
      "EW18": 1448,
      "EW3": 1409,
      "EW2": 1406,
      "EW4": 1413,
      "EW15": 1440,
      "EW17": 1445,
      "EW31": 1484,
      "EW32": 1486
    },
    "sunday-public-holiday": {
      "EW9": 1426,
      "EW5": 1416,
      "EW27": 1472,
      "EW12": 1433,
      "EW21": 1455,
      "EW25": 1467,
      "EW13": 1435,
      "EW23": 1460,
      "EW20": 1452,
      "EW22": 1457,
      "EW7": 1421,
      "EW30": 1481,
      "EW29": 1478,
      "EW24": 1465,
      "EW10": 1428,
      "EW6": 1419,
      "EW26": 1469,
      "EW11": 1430,
      "EW16": 1442,
      "EW1": 1403,
      "EW8": 1423,
      "EW28": 1475,
      "EW19": 1450,
      "EW14": 1438,
      "EW18": 1448,
      "EW3": 1409,
      "EW2": 1406,
      "EW15": 1440,
      "EW17": 1445,
      "EW31": 1484,
      "EW32": 1486
    },
    "public-holiday-eve": {
      "EW9": 1460,
      "EW5": 1450,
      "EW27": 1507,
      "EW12": 1467,
      "EW21": 1489,
      "EW25": 1501,
      "EW13": 1470,
      "EW23": 1494,
      "EW20": 1486,
      "EW22": 1492,
      "EW7": 1455,
      "EW30": 1515,
      "EW29": 1512,
      "EW24": 1499,
      "EW10": 1462,
      "EW6": 1453,
      "EW26": 1504,
      "EW11": 1465,
      "EW16": 1476,
      "EW1": 1437,
      "EW8": 1458,
      "EW28": 1509,
      "EW19": 1484,
      "EW14": 1472,
      "EW18": 1482,
      "EW3": 1443,
      "EW2": 1441,
      "EW4": 1447,
      "EW15": 1474,
      "EW17": 1478,
      "EW31": 1518,
      "EW32": 1520
    }
  },
  "EW_TO_PASIR_RIS": {
    "weekday": {
      "EW9": 1460,
      "EW5": 1470,
      "EW27": 1414,
      "EW12": 1453,
      "EW21": 1431,
      "EW25": 1419,
      "EW13": 1450,
      "EW23": 1426,
      "EW20": 1433,
      "EW22": 1429,
      "EW7": 1465,
      "EW30": 1406,
      "EW29": 1409,
      "EW24": 1422,
      "EW10": 1457,
      "EW6": 1467,
      "EW26": 1417,
      "EW11": 1455,
      "EW16": 1443,
      "EW8": 1462,
      "EW28": 1412,
      "EW19": 1435,
      "EW14": 1448,
      "EW18": 1438,
      "EW3": 1477,
      "EW2": 1479,
      "EW4": 1473,
      "EW15": 1445,
      "EW17": 1440,
      "EW31": 1403,
      "EW33": 1399,
      "EW32": 1401
    },
    "saturday": {
      "EW9": 1460,
      "EW5": 1470,
      "EW27": 1414,
      "EW12": 1453,
      "EW21": 1431,
      "EW25": 1419,
      "EW13": 1450,
      "EW23": 1426,
      "EW20": 1433,
      "EW22": 1429,
      "EW7": 1465,
      "EW30": 1406,
      "EW29": 1409,
      "EW24": 1422,
      "EW10": 1457,
      "EW6": 1467,
      "EW26": 1417,
      "EW11": 1455,
      "EW16": 1443,
      "EW8": 1462,
      "EW28": 1412,
      "EW19": 1435,
      "EW14": 1448,
      "EW18": 1438,
      "EW3": 1477,
      "EW2": 1479,
      "EW4": 1473,
      "EW15": 1445,
      "EW17": 1440,
      "EW31": 1403,
      "EW33": 1399,
      "EW32": 1401
    },
    "sunday-public-holiday": {
      "EW9": 1460,
      "EW5": 1470,
      "EW27": 1414,
      "EW12": 1453,
      "EW21": 1431,
      "EW25": 1419,
      "EW13": 1450,
      "EW23": 1426,
      "EW20": 1433,
      "EW22": 1429,
      "EW7": 1465,
      "EW30": 1406,
      "EW29": 1409,
      "EW24": 1422,
      "EW10": 1457,
      "EW6": 1467,
      "EW26": 1417,
      "EW11": 1455,
      "EW16": 1443,
      "EW8": 1462,
      "EW28": 1412,
      "EW19": 1435,
      "EW14": 1448,
      "EW18": 1438,
      "EW3": 1477,
      "EW2": 1479,
      "EW4": 1473,
      "EW15": 1445,
      "EW17": 1440,
      "EW31": 1403,
      "EW33": 1399,
      "EW32": 1401
    },
    "public-holiday-eve": {
      "EW9": 1479,
      "EW5": 1489,
      "EW27": 1432,
      "EW12": 1472,
      "EW21": 1450,
      "EW25": 1437,
      "EW13": 1470,
      "EW23": 1445,
      "EW20": 1452,
      "EW22": 1447,
      "EW7": 1484,
      "EW30": 1424,
      "EW29": 1427,
      "EW24": 1440,
      "EW10": 1476,
      "EW6": 1486,
      "EW26": 1435,
      "EW11": 1474,
      "EW16": 1462,
      "EW8": 1481,
      "EW28": 1430,
      "EW19": 1455,
      "EW14": 1467,
      "EW18": 1457,
      "EW3": 1495,
      "EW2": 1498,
      "EW4": 1492,
      "EW15": 1465,
      "EW17": 1459,
      "EW31": 1422,
      "EW33": 1417,
      "EW32": 1419
    }
  },
  "BP_LOOP_B": {
    "weekday": {
      "BP9": 1406,
      "BP6": 1417,
      "BP10": 1404,
      "BP12": 1400,
      "BP8": 1407,
      "BP7": 1409,
      "BP11": 1402,
      "BP13": 1399
    },
    "saturday": {
      "BP9": 1406,
      "BP6": 1417,
      "BP10": 1404,
      "BP12": 1400,
      "BP8": 1407,
      "BP7": 1409,
      "BP11": 1402,
      "BP13": 1399
    },
    "sunday-public-holiday": {
      "BP9": 1406,
      "BP6": 1417,
      "BP12": 1400,
      "BP8": 1407,
      "BP7": 1409,
      "BP11": 1402,
      "BP13": 1399
    },
    "public-holiday-eve": {
      "BP9": 1406,
      "BP6": 1417,
      "BP10": 1404,
      "BP12": 1400,
      "BP8": 1407,
      "BP7": 1409,
      "BP11": 1402,
      "BP13": 1399
    }
  },
  "CC_LOOP_CLOCKWISE": {
    "weekday": {
      "CC12": 1408,
      "CC34": 1428,
      "CC15": 1400,
      "CC19": 1390,
      "CC22": 1383,
      "CC17": 1395,
      "CC31": 1363,
      "CC8": 1417,
      "CC20": 1388,
      "CC29": 1367,
      "CC25": 1376,
      "CC21": 1385,
      "CC24": 1379,
      "CC30": 1364,
      "CC27": 1372,
      "CC14": 1403,
      "CC10": 1412,
      "CC16": 1397,
      "CC7": 1419,
      "CC5": 1423,
      "CC23": 1381,
      "CC26": 1374,
      "CC9": 1415,
      "CC32": 1360,
      "CC4": 1425,
      "CC13": 1405,
      "CC6": 1421,
      "CC11": 1410,
      "CC28": 1370
    },
    "saturday": {
      "CC12": 1408,
      "CC34": 1428,
      "CC15": 1400,
      "CC19": 1390,
      "CC22": 1383,
      "CC17": 1395,
      "CC31": 1363,
      "CC8": 1417,
      "CC20": 1388,
      "CC29": 1367,
      "CC25": 1376,
      "CC21": 1385,
      "CC24": 1379,
      "CC30": 1364,
      "CC27": 1372,
      "CC14": 1403,
      "CC10": 1412,
      "CC16": 1397,
      "CC7": 1419,
      "CC5": 1423,
      "CC23": 1381,
      "CC26": 1374,
      "CC9": 1415,
      "CC32": 1360,
      "CC4": 1425,
      "CC13": 1405,
      "CC6": 1421,
      "CC11": 1410,
      "CC28": 1370
    },
    "sunday-public-holiday": {
      "CC12": 1408,
      "CC34": 1428,
      "CC15": 1400,
      "CC19": 1390,
      "CC22": 1383,
      "CC17": 1395,
      "CC31": 1363,
      "CC8": 1417,
      "CC20": 1388,
      "CC29": 1367,
      "CC25": 1376,
      "CC21": 1385,
      "CC24": 1379,
      "CC30": 1364,
      "CC27": 1372,
      "CC14": 1403,
      "CC10": 1412,
      "CC16": 1397,
      "CC7": 1419,
      "CC5": 1423,
      "CC23": 1381,
      "CC26": 1374,
      "CC9": 1415,
      "CC32": 1360,
      "CC4": 1425,
      "CC13": 1405,
      "CC6": 1421,
      "CC11": 1410,
      "CC28": 1370
    }
  },
  "CC_LOOP_ANTICLOCKWISE": {
    "weekday": {
      "CC12": 1390,
      "CC34": 1370,
      "CC15": 1398,
      "CC19": 1408,
      "CC22": 1414,
      "CC17": 1403,
      "CC31": 1435,
      "CC8": 1380,
      "CC20": 1410,
      "CC29": 1431,
      "CC25": 1421,
      "CC21": 1412,
      "CC24": 1419,
      "CC30": 1433,
      "CC27": 1426,
      "CC14": 1395,
      "CC10": 1385,
      "CC33": 1368,
      "CC16": 1400,
      "CC7": 1378,
      "CC5": 1374,
      "CC23": 1417,
      "CC26": 1423,
      "CC9": 1383,
      "CC4": 1372,
      "CC13": 1393,
      "CC6": 1376,
      "CC11": 1387,
      "CC28": 1427
    },
    "saturday": {
      "CC12": 1390,
      "CC34": 1370,
      "CC15": 1398,
      "CC19": 1408,
      "CC22": 1414,
      "CC17": 1403,
      "CC31": 1435,
      "CC8": 1380,
      "CC20": 1410,
      "CC29": 1431,
      "CC25": 1421,
      "CC21": 1412,
      "CC24": 1419,
      "CC30": 1433,
      "CC27": 1426,
      "CC14": 1395,
      "CC10": 1385,
      "CC33": 1368,
      "CC16": 1400,
      "CC7": 1378,
      "CC5": 1374,
      "CC23": 1417,
      "CC26": 1423,
      "CC9": 1383,
      "CC4": 1372,
      "CC13": 1393,
      "CC6": 1376,
      "CC11": 1387,
      "CC28": 1427
    },
    "sunday-public-holiday": {
      "CC12": 1390,
      "CC34": 1370,
      "CC15": 1398,
      "CC19": 1408,
      "CC22": 1414,
      "CC17": 1403,
      "CC31": 1435,
      "CC8": 1380,
      "CC20": 1410,
      "CC29": 1431,
      "CC25": 1421,
      "CC21": 1412,
      "CC24": 1419,
      "CC30": 1433,
      "CC27": 1426,
      "CC14": 1395,
      "CC10": 1385,
      "CC33": 1368,
      "CC16": 1400,
      "CC7": 1378,
      "CC5": 1374,
      "CC23": 1417,
      "CC26": 1423,
      "CC9": 1383,
      "CC4": 1372,
      "CC13": 1393,
      "CC6": 1376,
      "CC11": 1387,
      "CC28": 1427
    }
  },
  "TE_TO_WOODLANDS_NORTH": {
    "weekday": {
      "TE29": 1422,
      "TE7": 1468,
      "TE9": 1463,
      "TE22": 1439,
      "TE15": 1450,
      "TE16": 1449,
      "TE24": 1432,
      "TE5": 1472,
      "TE20": 1442,
      "TE26": 1428,
      "TE27": 1426,
      "TE18": 1445,
      "TE6": 1470,
      "TE12": 1456,
      "TE14": 1453,
      "TE13": 1454,
      "TE17": 1447,
      "TE19": 1443,
      "TE28": 1424,
      "TE4": 1475,
      "TE11": 1459,
      "TE25": 1430,
      "TE23": 1435,
      "TE8": 1466,
      "TE2": 1482,
      "TE1": 1484,
      "TE3": 1480
    },
    "saturday": {
      "TE29": 1422,
      "TE7": 1468,
      "TE9": 1463,
      "TE22": 1439,
      "TE15": 1450,
      "TE16": 1449,
      "TE24": 1432,
      "TE5": 1472,
      "TE20": 1442,
      "TE26": 1428,
      "TE27": 1426,
      "TE18": 1445,
      "TE6": 1470,
      "TE12": 1456,
      "TE14": 1453,
      "TE13": 1454,
      "TE17": 1447,
      "TE19": 1443,
      "TE28": 1424,
      "TE4": 1475,
      "TE11": 1459,
      "TE25": 1430,
      "TE23": 1435,
      "TE8": 1466,
      "TE2": 1482,
      "TE1": 1484,
      "TE3": 1480
    },
    "sunday-public-holiday": {
      "TE29": 1422,
      "TE7": 1468,
      "TE9": 1463,
      "TE22": 1439,
      "TE15": 1450,
      "TE16": 1449,
      "TE24": 1432,
      "TE5": 1472,
      "TE20": 1442,
      "TE26": 1428,
      "TE27": 1426,
      "TE18": 1445,
      "TE6": 1470,
      "TE12": 1456,
      "TE14": 1453,
      "TE13": 1454,
      "TE17": 1447,
      "TE19": 1443,
      "TE28": 1424,
      "TE4": 1475,
      "TE11": 1459,
      "TE25": 1430,
      "TE23": 1435,
      "TE8": 1466,
      "TE2": 1482,
      "TE1": 1484,
      "TE3": 1480
    },
    "public-holiday-eve": {
      "TE29": 1452,
      "TE7": 1498,
      "TE9": 1493,
      "TE22": 1469,
      "TE15": 1480,
      "TE16": 1479,
      "TE24": 1462,
      "TE5": 1502,
      "TE20": 1472,
      "TE26": 1458,
      "TE27": 1456,
      "TE18": 1475,
      "TE6": 1500,
      "TE12": 1486,
      "TE14": 1483,
      "TE13": 1484,
      "TE17": 1477,
      "TE19": 1473,
      "TE28": 1454,
      "TE4": 1505,
      "TE11": 1489,
      "TE25": 1460,
      "TE23": 1465,
      "TE8": 1496,
      "TE2": 1512,
      "TE3": 1510
    }
  },
  "TE_TO_BAYSHORE": {
    "weekday": {
      "TE29": 1473,
      "TE7": 1427,
      "TE9": 1432,
      "TE22": 1457,
      "TE15": 1445,
      "TE16": 1447,
      "TE24": 1463,
      "TE5": 1422,
      "TE20": 1454,
      "TE26": 1467,
      "TE27": 1469,
      "TE18": 1450,
      "TE6": 1425,
      "TE12": 1439,
      "TE14": 1443,
      "TE13": 1441,
      "TE17": 1449,
      "TE19": 1452,
      "TE28": 1471,
      "TE4": 1419,
      "TE11": 1436,
      "TE25": 1465,
      "TE23": 1461,
      "TE8": 1429,
      "TE2": 1413,
      "TE1": 1410,
      "TE3": 1415
    },
    "saturday": {
      "TE29": 1473,
      "TE7": 1427,
      "TE9": 1432,
      "TE22": 1457,
      "TE15": 1445,
      "TE16": 1447,
      "TE24": 1463,
      "TE5": 1422,
      "TE20": 1454,
      "TE26": 1467,
      "TE27": 1469,
      "TE18": 1450,
      "TE6": 1425,
      "TE12": 1439,
      "TE14": 1443,
      "TE13": 1441,
      "TE17": 1449,
      "TE19": 1452,
      "TE28": 1471,
      "TE4": 1419,
      "TE11": 1436,
      "TE25": 1465,
      "TE23": 1461,
      "TE8": 1429,
      "TE2": 1413,
      "TE1": 1410,
      "TE3": 1415
    },
    "sunday-public-holiday": {
      "TE29": 1473,
      "TE7": 1427,
      "TE9": 1432,
      "TE22": 1457,
      "TE15": 1445,
      "TE16": 1447,
      "TE24": 1463,
      "TE5": 1422,
      "TE20": 1454,
      "TE26": 1467,
      "TE27": 1469,
      "TE18": 1450,
      "TE6": 1425,
      "TE12": 1439,
      "TE14": 1443,
      "TE13": 1441,
      "TE17": 1449,
      "TE19": 1452,
      "TE28": 1471,
      "TE4": 1419,
      "TE11": 1436,
      "TE25": 1465,
      "TE23": 1461,
      "TE8": 1429,
      "TE2": 1413,
      "TE1": 1410,
      "TE3": 1415
    },
    "public-holiday-eve": {
      "TE29": 1473,
      "TE7": 1457,
      "TE9": 1462,
      "TE22": 1487,
      "TE15": 1475,
      "TE16": 1477,
      "TE24": 1493,
      "TE5": 1452,
      "TE20": 1484,
      "TE26": 1497,
      "TE27": 1499,
      "TE18": 1480,
      "TE6": 1455,
      "TE12": 1469,
      "TE14": 1473,
      "TE13": 1471,
      "TE17": 1479,
      "TE19": 1482,
      "TE28": 1501,
      "TE4": 1449,
      "TE11": 1466,
      "TE25": 1495,
      "TE23": 1491,
      "TE8": 1459,
      "TE1": 1440,
      "TE3": 1445
    }
  },
  "CC_SPUR_TO_DHOBY_GHAUT": {
    "weekday": {
      "CC2": 1441,
      "CC3": 1439,
      "CC5": 1434,
      "CC4": 1436,
      "CC6": 1432
    },
    "saturday": {
      "CC2": 1441,
      "CC3": 1439,
      "CC5": 1434,
      "CC4": 1436,
      "CC6": 1432
    },
    "sunday-public-holiday": {
      "CC2": 1441,
      "CC3": 1439,
      "CC5": 1434,
      "CC4": 1436,
      "CC6": 1432
    }
  },
  "CC_SPUR_TO_STADIUM": {
    "weekday": {
      "CC2": 1438,
      "CC1": 1436,
      "CC3": 1440,
      "CC5": 1444,
      "CC4": 1442
    },
    "saturday": {
      "CC2": 1438,
      "CC1": 1436,
      "CC3": 1440,
      "CC5": 1444,
      "CC4": 1442
    },
    "sunday-public-holiday": {
      "CC2": 1438,
      "CC1": 1436,
      "CC3": 1440,
      "CC5": 1444,
      "CC4": 1442
    }
  },
  "NS_SHORT_TO_KRANJI": {
    "public-holiday-eve": {
      "NS2": 1503,
      "NS3": 1505,
      "NS4": 1509,
      "NS5": 1512
    }
  },
  "BP_TRUNK_TO_BUKIT_PANJANG": {
    "weekday": {
      "BP6": 1417,
      "BP1": 1410,
      "BP3": 1413,
      "BP5": 1415,
      "BP2": 1411,
      "BP4": 1414
    },
    "saturday": {
      "BP6": 1417,
      "BP1": 1410,
      "BP3": 1413,
      "BP5": 1415,
      "BP2": 1411,
      "BP4": 1414
    },
    "sunday-public-holiday": {
      "BP6": 1417,
      "BP1": 1410,
      "BP3": 1413,
      "BP5": 1415,
      "BP4": 1414
    },
    "public-holiday-eve": {
      "BP6": 1417,
      "BP1": 1410,
      "BP3": 1413,
      "BP5": 1415,
      "BP2": 1411,
      "BP4": 1414
    }
  },
  "CG_TO_TANAH_MERAH": {
    "weekday": {
      "CG2": 1446,
      "CG1": 1403
    },
    "saturday": {
      "CG2": 1446,
      "CG1": 1403
    },
    "sunday-public-holiday": {
      "CG2": 1446,
      "CG1": 1403
    },
    "public-holiday-eve": {
      "CG2": 1398
    }
  },
  "CG_TO_CHANGI_AIRPORT": {
    "weekday": {
      "CG1": 1433,
      "EW4": 1430
    },
    "saturday": {
      "CG1": 1433,
      "EW4": 1430
    },
    "sunday-public-holiday": {
      "CG1": 1433
    },
    "public-holiday-eve": {
      "CG1": 1433,
      "EW4": 1430
    }
  }
}
